<template>
    <div v-if="type === 'select'" class="j-link-address-wrap">
      <el-select v-model="province" v-bind="$attrs" placeholder="选择省" @change="provinceChange" :clearable="clearable">
        <el-option v-for="item in provinceOption" :key="item.areaId" :label="item.name" :value="item.areaId" />
      </el-select>
      <template v-if="scope === 'city' || scope === 'district'">
        <el-select v-model="city" v-bind="$attrs" placeholder="选择市" @change="cityChange" :clearable="clearable">
          <el-option v-for="item in cityOption" :key="item.areaId" :label="item.name" :value="item.areaId" />
        </el-select>
        <el-select v-if="scope === 'district'" v-model="district" v-bind="$attrs" placeholder="选择区" @change="districtChange" :clearable="clearable">
          <el-option v-for="item in districtOption" :key="item.areaId" :label="item.name" :value="item.areaId" />
        </el-select>
      </template>
    </div>
    <span v-else>
      {{text}}
    </span>
</template>

<script>
    import {mapActions, mapState} from "vuex";
    export default {
        name: "JLinkAddress",
        props: {
            value: {
                type: [Array, String]
            },
            type: {
                type: String,
                default: 'select'
            },
            valueType: { // String/Array
                type: String,
                default: 'String'
            },
            separator: {
                // 分隔符
                type: String,
                default: '-'
            },
            textSeparator: {
                // 文本模式分隔符
                type: String,
                default: '-'
            },
            clearable: {
                type: Boolean,
                default: true
            },
            scope: { // province/city/district
                type: String,
                default: 'district'
            }
        },
      computed: {
        ...mapState('JLinkAddress', {
          areaIdNameMap: state => state.areaIdNameMap
        })
      },
        data() {
            return {
              text: '',
              selected: [],
              province: '', // 省
              city: '', // 市
              district: '', // 区
              provinceOption: [],
              cityOption: [],
              districtOption: []
            }
        },
        async created () {
          this.provinceOption = await this.getAddressById()
          this.updateAddress(this.value)
        },
        methods: {
          ...mapActions('JLinkAddress', ['getAddressById']),
          getTextByAreaId (areaId) {
            return this.areaIdNameMap[areaId] || areaId
          },
          updateAddress (value) {
            if (Array.isArray(value)) {
              this.selected = value
              this.handleSelected(this.selected)
            } else {
              if (value) {
                this.selected = value.split(this.separator)
                this.handleSelected(this.selected)
              } else {
                this.province = ''
                this.city = ''
                this.district = ''
                this.selected = []
                this.cityOption = []
                this.districtOption = []
              }
            }
          },
          async handleSelected (array) {
            this.province = String(array[0] || '')
            this.city = String(array[1] || '')
            this.district = String(array[2] || '')
            if (this.province) this.cityOption = await this.getAddressById(this.province)
            if (this.city) this.districtOption = await this.getAddressById(this.city)
            if (this.type === 'text') setTimeout(() => {
              this.text = array.map(code => this.getTextByAreaId(code)).join(this.textSeparator)
            }, 0)
          },
          async provinceChange (province) {
            this.city = ''
            this.district = ''
            this.cityOption = []
            this.districtOption = []
            if (province) this.cityOption = await this.getAddressById(province)
            this.updateData()
            this.$emit('change', province, this.selected, this.selected.map(area => this.areaIdNameMap[area]))
          },
          async cityChange (city) {
            this.district = ''
            this.districtOption = []
            if (city) this.districtOption = await this.getAddressById(city)
            this.updateData()
            this.$emit('change', city, this.selected, this.selected.map(area => this.areaIdNameMap[area]))
          },
          districtChange (district) {
            this.updateData()
            this.$emit('change', district, this.selected, this.selected.map(area => this.areaIdNameMap[area]))
          },
          updateData () {
              this.selected = []
              if (this.province) this.selected.push(this.province)
              if (this.city) this.selected.push(this.city)
              if (this.district) this.selected.push(this.district)
              if (this.valueType === 'Array') this.$emit('input', this.selected)
              else this.$emit('input', this.selected.join(this.separator))
          }
        },
        watch: {
            value: {
              handler (nv) {
                if (nv) {
                  if (this.type === 'text') {
                    this.updateAddress(nv)
                  } else {
                    if (this.valueType === 'String') {
                      !(nv === this.selected.join(this.separator)) && this.updateAddress(nv)
                    } else {
                      // !(nv === this.selected) && this.updateAddress(nv)
                      this.updateAddress(nv) // 数组进行深度监听
                    }
                  }
                } else {
                  this.updateAddress(nv)
                }
              },
              deep: true // 数组进行深度监听
            }
        }
    }
</script>

<style lang="scss">
    .j-link-address-wrap {
      display: flex;
      width: 100%;
      border-radius: 4px;
      border: 1px solid #DCDFE6;
      box-sizing: border-box;
      overflow: hidden;
      > .el-select {
        flex: 1;
      }
      .el-input__inner {
        border: none;
      }
    }
    .is-error {
      .j-link-address-wrap {
        border-color: #F56C6C;
      }
    }
</style>
